import React, { useEffect } from 'react'
import { compose } from 'redux'
import { Form } from 'antd'
import _ from 'lodash'
import dayjs from "dayjs"

import ClientUsersHOC from './actions'
import WithCountry from "./actions/country"

import CoreRenderFunction from 'DisplayCore'
import { JomBizKYC } from 'PageLayout/Jombiz/KYC'

const KYCMember = props => {
  const {
    profile,
    onChangeClientUsersHOC,
    getBanks,
    getAddresses,
    updateClientUser,
    showKYC,
    updateShowKYC,
    uploadedICFront,
    uploadedICBack,
    banks,
    ICFrontImageInfo,
    ICBackImageInfo,
    uploadedBankStatement,
    BankStatementImageInfo,
    selectedDocumentType,
    uploadedSSMCert,
    SSMCertImageInfo,
    SSMWithICImageInfo,
    showFormFeedbackICFront,
    showFormFeedbackICBack,
    showFormFeedbackBankStatement,
    showFormFeedbackSSMCert,
    showAccountOwnerShipMessage,
    residentialAddress,

    // country
    getCountriesOption,
    getStatesOption,
    getCitiesOption,
  } = props

  const [kycForm] = Form.useForm()
  const selectedCountry = Form.useWatch('country_iso2', kycForm)
  const selectedState = Form.useWatch('state', kycForm)
  const selectedAccountOwnership = Form.useWatch('account_ownership', kycForm)
  const ic_number = Form.useWatch("ic_number", kycForm);

  useEffect(() => {
    getBanks()
    getCountriesOption()
  }, [])

  useEffect(() => {
    if (showKYC && profile.id) {
      getAddresses()
    }
  }, [showKYC, profile])

  useEffect(() => {
    if (selectedCountry) {
      getStatesOption(selectedCountry)
      kycForm.setFieldsValue({
        state: undefined,
        city: undefined,
      })
    }
  }, [selectedCountry])

  useEffect(() => {
    if (selectedState) {
      getCitiesOption(selectedCountry, selectedState)
      kycForm.setFieldsValue({
        city: undefined,
      })
    }
  }, [selectedState])

  useEffect(() => {
    if (selectedAccountOwnership) {
      if (selectedAccountOwnership === 'others') {
        onChangeClientUsersHOC('showAccountOwnerShipMessage', true)
      } else {
        onChangeClientUsersHOC('showAccountOwnerShipMessage', false)
      }
    }
  }, [selectedAccountOwnership])
  // inside KYCMember, right after your watches
  const documentType = Form.useWatch('document_type', kycForm);
  // const ic_number = Form.useWatch('ic_number', kycForm);

  // disable gender when IC is chosen
  const disabledGender = documentType?.toLowerCase() === 'ic';

  useEffect(() => {
    if (documentType?.toLowerCase() !== 'ic') return;

    if (ic_number?.length === 12 && /^[0-9]{12}$/.test(ic_number)) {
      const genderDigit = parseInt(ic_number[11], 10);
      const gender = genderDigit % 2 === 0 ? 'female' : 'male';

      let year = parseInt(ic_number.slice(0, 2), 10);
      const month = ic_number.slice(2, 4);
      const day = ic_number.slice(4, 6);

      const currentYear = parseInt(dayjs().format('YY'), 10);
      if (year > currentYear) {
        year = `19${year}`;
      } else {
        year = year < 10 ? `200${year}` : `20${year}`;
      }

      const formattedDate = dayjs(`${year}-${month}-${day}`);
      if (formattedDate.isValid()) {
        kycForm.setFieldsValue({
          gender,
          date_of_birth: formattedDate,
        });
      }
    }
  }, [ic_number, documentType]);


  useEffect(() => {
    if (!_.isEmpty(residentialAddress)) {
      kycForm.setFieldsValue({
        address_line1: residentialAddress.address_line1 === 'N/A' ? '' : residentialAddress.address_line1,
        address_line2: residentialAddress.address_line2 === 'N/A' ? '' : residentialAddress.address_line2,
        address_line2: residentialAddress.address_line3 === 'N/A' ? '' : residentialAddress.address_line3,
        country_iso2: residentialAddress.country_iso2 === 'N/A' ? '' : residentialAddress.country_iso2,
        state: residentialAddress.state === 'N/A' ? '' : residentialAddress.state,
        city: residentialAddress.city === 'N/A' ? '' : residentialAddress.city,
        postcode: residentialAddress.postcode === 'N/A' ? '' : residentialAddress.postcode,
      })
    }
  }, [residentialAddress])

  const onClickAction = (actionKey, value) => {
    switch (actionKey) {
      case 'CLOSE_KYC':
        updateShowKYC(false)
        break
      case 'UPLOAD_IC_FRONT':
        if (value && value.length > 0) {
          onChangeClientUsersHOC('uploadedICFront', value)
          const reader = new FileReader()
          reader.onload = () => {
            onChangeClientUsersHOC('ICFrontImageInfo', {
              base64: reader.result,
              file_name: value[0]?.filename
            }
            )
          }
          reader.readAsDataURL(value[0]?.file)
        }
        onChangeClientUsersHOC('showFormFeedbackICFront', false)
        break
      case 'UPLOAD_IC_BACK':
        if (value && value.length > 0) {
          onChangeClientUsersHOC('uploadedICBack', value)
          const reader = new FileReader()
          reader.onload = () => {
            onChangeClientUsersHOC('ICBackImageInfo', {
              base64: reader.result,
              file_name: value[0]?.filename
            }
            )
          }
          reader.readAsDataURL(value[0]?.file)
        }
        onChangeClientUsersHOC('showFormFeedbackICBack', false)
        break
      case 'UPLOAD_SSM_CERT':
        if (value && value.length > 0) {
          onChangeClientUsersHOC('uploadedSSMCert', value)
          const reader = new FileReader()
          reader.onload = () => {
            onChangeClientUsersHOC('SSMCertImageInfo', {
              base64: reader.result,
              file_name: value[0]?.filename
            }
            )
          }
          reader.readAsDataURL(value[0]?.file)
        }
        onChangeClientUsersHOC('showFormFeedbackSSMCert', false)
        break
      case 'UPLOAD_SSM_CERT_WITH_IC':
        if (value && value.length > 0) {
          onChangeClientUsersHOC('uploadedSSMCertWithIC', value)
          const reader = new FileReader()
          reader.onload = () => {
            onChangeClientUsersHOC('SSMWithICImageInfo', {
              base64: reader.result,
              file_name: value[0]?.filename
            }
            )
          }
          reader.readAsDataURL(value[0]?.file)
        }
        break
      case 'ON_CHANGE_KYC_FORM':
        if (value.hasOwnProperty('document_type')) {
          onChangeClientUsersHOC('selectedDocumentType', value.document_type)
          // Force revalidate the affected fields
          kycForm.validateFields(['date_of_birth', 'ic_number']);

          console.log(value.document_type)
        }
        break
      case 'UPLOAD_BANK_STATEMENT':
        if (value && value.length > 0) {
          onChangeClientUsersHOC('uploadedBankStatement', value)
          const reader = new FileReader()
          reader.onload = () => {
            onChangeClientUsersHOC('BankStatementImageInfo', {
              base64: reader.result,
              file_name: value[0].filename
            }
            )
          }
          reader.readAsDataURL(value[0]?.file)
        }
        onChangeClientUsersHOC('showFormFeedbackBankStatement', false)
        break
      default: break
    }
  }

  const hideComponent = actionKey => {
    switch (actionKey) {
      case 'hideFormFeedbackICFront':
        return !showFormFeedbackICFront
      case 'hideFormFeedbackICBack':
        return !showFormFeedbackICBack
      case 'hideFormFeedbackBankStatement':
        return !showFormFeedbackBankStatement
      case 'hideSSM':
        return ['passport', 'ic'].includes(selectedDocumentType?.toLowerCase());
      case 'hideBackIC':
        return selectedDocumentType === 'passport'
      case 'hideFormFeedbackSSMCert':
        return !showFormFeedbackSSMCert
      case 'hideAccountOwnerShipMessage':
        return !showAccountOwnerShipMessage
      default: return false
    }
  }

  const onInitialtKYCForm = form => {
    form.setFieldsValue({
      holder_name: profile.full_name,
      document_type: 'ic',
    })

    if (!_.isEmpty(residentialAddress)) {
      form.setFieldsValue({
        address_line1: residentialAddress.address_line1,
        address_line2: residentialAddress.address_line2,
        address_line2: residentialAddress.address_line3,
        country_iso2: residentialAddress.country_iso2,
        state: residentialAddress.state,
        city: residentialAddress.city,
        postcode: residentialAddress.postcode,
      })
    }
  }

  const onSubmitKYCForm = formData => {
    if (_.isEmpty(uploadedICFront)) {
      onChangeClientUsersHOC('showFormFeedbackICFront', true)
    }
    if (_.isEmpty(uploadedICBack)) {
      onChangeClientUsersHOC('showFormFeedbackICBack', true)
    }
    if (_.isEmpty(uploadedBankStatement)) {
      onChangeClientUsersHOC('showFormFeedbackBankStatement', true)
    }
    if (profile.is_company && _.isEmpty(SSMCertImageInfo)) {
      onChangeClientUsersHOC('showFormFeedbackSSMCert', true)
      return
    }
    if (_.isEmpty(uploadedICFront)
      || _.isEmpty(uploadedICBack)
      || _.isEmpty(uploadedBankStatement)
      || (profile.is_company && _.isEmpty(SSMCertImageInfo))) {
      return
    }

    // let bank_id = _.find( banks, { value: formData.bank_value })?.id || null
    let data = {
      bank_id: formData.bank_id || null,
      // ...( bank_id && { bank_id: bank_id }),
      // ...( !bank_id && { bank_name: formData.bank_value }),
      account_number: formData.account_number || null,
      holder_name: formData.holder_name || 'N/A',
      is_default: true,
      income_tax_number: formData.income_tax_number || '',
      security_pin: formData.security_pin || '999999',
      security_pin_confirmation: formData.security_pin_confirmation || '999999',
      ic_front: ICFrontImageInfo,
      account_ownership: formData.account_ownership || 'self'
    }
    if (!_.isEmpty(ICBackImageInfo)) {
      data.ic_back = ICBackImageInfo
    }
    if (!_.isEmpty(BankStatementImageInfo)) {
      data.bank_statement = BankStatementImageInfo
    }
    if (!_.isEmpty(SSMCertImageInfo)) {
      data.ssm_cert = SSMCertImageInfo
    }
    if (formData.document_type === 'ssm') {
      data.ssm_cert = SSMCertImageInfo
      if (!_.isEmpty(SSMWithICImageInfo)) {
        data.ssm_cert_with_ic = SSMWithICImageInfo
      }
    }

    data.document_type = formData.document_type
    data.ic_number = formData.ic_number
    data.gender = formData.gender
    data.date_of_birth = formData.date_of_birth

    data.address = {
      ...residentialAddress,
      address_line1: formData.address_line1,
      address_line2: formData.address_line2 || '',
      address_line3: formData.address_line3 || '',
      country_iso2: formData.country_iso2,
      state: formData.state,
      city: formData.city,
      postcode: formData.postcode,
    }

    updateClientUser(profile.id, data)
  }

  return (
    <>
      {
        showKYC && (
          <CoreRenderFunction
            {...props}
            disabledGender={disabledGender}
            item={JomBizKYC.content}
            onClickAction={onClickAction}
            hideComponent={hideComponent}
            onInitialtKYCForm={onInitialtKYCForm}
            onSubmitKYCForm={onSubmitKYCForm}
            kycForm={kycForm}
          />
        )
      }
    </>
  )
}

export default compose(
  ClientUsersHOC,
  WithCountry
)(KYCMember)
